const loadedScripts = new Map();
/**
 * Загружает скрипт на страницу.
 * Адреса загруженных скриптов складываются в кэш, чтобы избежать повторной загрузки.
 *
 * @param options Опции загрузки скрипта
 * @example
 * ```ts
 * // Загрузка внешнего скрипта
 * await loadScript({
 *   src: 'https://example.com/script.js',
 *   crossOrigin: 'anonymous'
 * });
 *
 * // Загрузка скрипта с CSP nonce
 * await loadScript({
 *   src: '/local-script.js',
 *   cspNonce: 'abc123'
 * });
 * ```
 */
export async function loadScript({ src, cspNonce, crossOrigin = 'anonymous', dataTestId }) {
    let scriptDomEl;
    const loadedScript = loadedScripts.get(src);
    if (loadedScript) {
        return loadedScript;
    }
    const promise = new Promise((resolve, reject) => {
        scriptDomEl = document.createElement('script');
        scriptDomEl.async = true;
        if (cspNonce) {
            scriptDomEl.nonce = cspNonce;
        }
        if (crossOrigin !== 'disabled') {
            scriptDomEl.crossOrigin = crossOrigin;
        }
        if (dataTestId) {
            scriptDomEl.setAttribute('data-testid', dataTestId);
        }
        scriptDomEl.addEventListener('load', () => {
            resolve();
        });
        scriptDomEl.addEventListener('error', () => {
            reject(new DOMException(`Failed to load script ${src}`, 'ResourceLoadError'));
        });
        scriptDomEl.src = src;
        document.body.appendChild(scriptDomEl);
    });
    loadedScripts.set(src, promise);
    return promise;
}
/**
 * Очищает кэш с адресами загруженных скриптов.
 */
export function clearLoadedScriptsCache(src) {
    if (src) {
        loadedScripts.delete(src);
    }
    else {
        loadedScripts.clear();
    }
}
